<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4
            slot="header"
            class="card-title text-left"
            style="padding: 0px; margin: 0px;"
            v-if="dadosFuncionario"
          >
            <b>Funcionário:</b> {{ dadosFuncionario.nome }}
          </h4>
          <div>
            <div class="row">
              <div class="col-md-4 text-left">
                <base-input
                  label="De"
                  type="date"
                  :max="moment(dataFinal).format('YYYY-MM-DD')"
                  v-model="dataInicial"
                >
                </base-input>
              </div>

              <div class="col-md-4 text-left">
                <base-input
                  label="Até"
                  type="date"
                  :min="moment(dataInicial).format('YYYY-MM-DD')"
                  v-model="dataFinal"
                  :disabled="!dataInicial ? true : false"
                >
                </base-input>
              </div>
              <div class="col-md-4 text-left mt-3">
                <base-button type="success" @click="carregarDias()"
                  >Gerar</base-button
                >
              </div>
            </div>

            <div
              class="row d-flex justify-content-between"
              v-if="diaSelecionar.length > 0"
            >
              <div class="col-md-6">
                <base-input
                  class="text-left"
                  label="Selecione o dia da semana ou clique individualmente para selecionar os dias de FOLGA"
                >
                  <select
                    v-model="diaSem"
                    class="form-control"
                    id="exampleFormControlSelect1"
                  >
                    <option value="0">Domingo</option>
                    <option value="1">Segunda</option>
                    <option value="2">Terça</option>
                    <option value="3">Quarta</option>
                    <option value="4">Quinta</option>
                    <option value="5">Sexta</option>
                    <option value="6">Sábado</option>
                  </select>
                </base-input>
                <base-button
                  block
                  type="default"
                  @click="aplicarDiaSemana(diaSem)"
                  >Aplicar</base-button
                >
              </div>
              <div class="col-md-6">
                <!-- <div class="table-responsive"> -->
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Folga</th>
                      <th scope="col">Dia</th>
                      <th scope="col">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in diaSelecionar" :key="item.id">
                      <td>
                        <base-checkbox v-model="item.folga"></base-checkbox>
                      </td>
                      <td>{{ item.dia }}</td>
                      <td>{{ item.data }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- </div> -->
                <base-button
                  type="success"
                  block
                  class="animation-on-hover"
                  style="margin: 0px 5px 0px 5px;"
                  @click="salvarFolga()"
                  >Salvar</base-button
                >
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../../../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
// import NotificationHorarioLimite from "../Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "cadastrar-escalas",
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      diaSelecionar: [],
      diaSem: 0,
      entrada1: "",
      entrada2: "",
      entrada3: "",
      saida1: "",
      saida2: "",
      saida3: "",
      intervaloInicial: "",
      intervaloFinal: "",
      horarioSelecionado: "",
      escalaManual: 1,
      qtdColunasSelecionadas: 4,
      dataInicial: "",
      dataFinal: new Date(),
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120,
        },
      ],
      tableData: users,
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    let th = this;
    jwt.verify(this.$route.params.id, "qXTflPwOaD", function(err, decoded) {
      if (decoded) {
        th.listarFuncionario(decoded.data.idFuncionario);
      }
    });

    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "email"],
      threshold: 0.3,
    });
  },
  methods: {
    moment: function(data) {
      return moment(data);
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    salvarFolga() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregados: this.dadosFuncionario.id,
        datas: this.diaSelecionar,
      };
      this.axios
        .post("/api/folga/cadastrarFolga", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "fail") {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao inserir folga!",
              "error",
            );
          } else {
            if (response.data.data.status) {
              th.showSwal(
                "auto-close",
                "Sucesso",
                "Sucesso ao inserir folga!",
                "success",
              );
            } else {
              th.showSwal(
                "auto-close",
                "Erro",
                response.data.data.err || "Erro ao tentar inserir folga!",
                "error",
              );
            }
            setTimeout(() => {
              th.$router.push("/pesquisarEscalaDepartamento");
            }, 2000);
          }
          // th.listDepartamentos = response.data.data.dados
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao inserir folga!", "error");
        });
    },

    aplicarDiaSemana(dia) {
      let cont = 0;
      this.diaSelecionar.map((data) => {
        if (dia == data.diaNumerico) {
          this.diaSelecionar[cont].folga = true;
        }
        cont++;
      });
    },

    verifyDay(day) {
      switch (day) {
        case 0:
          return "Domingo";

        case 1:
          return "Segunda";

        case 2:
          return "Terça";

        case 3:
          return "Quarta";

        case 4:
          return "Quinta";

        case 5:
          return "Sexta";

        case 6:
          return "Sábado";
      }
    },

    listarFuncionario(idFuncionario) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregado: idFuncionario,
      };
      this.axios
        .post("/api/empregado/selecionarEmpregadoPorId", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dadosFuncionario = response.data.data.dados[0];
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
        });
    },

    carregarDias() {
      this.diaSelecionar = [];
      let ano = this.moment(this.dataInicial).format("YYYY");
      let mes = this.moment(this.dataInicial).format("MMM");
      let dia = this.moment(this.dataInicial).format("DD");
      let date1 = new Date(mes + " " + dia + " " + ano);

      let ano2 = this.moment(this.dataFinal).format("YYYY");
      let mes2 = this.moment(this.dataFinal).format("MMM");
      let dia2 = this.moment(this.dataFinal).format("DD");
      let date2 = new Date(mes2 + " " + dia2 + " " + ano2);

      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      let primeiroDia = date1.getDay();
      let dataPrimeiroDia = this.dataInicial;
      let contId = 1;

      for (let i = 0; i <= diffDays; i++) {
        this.diaSelecionar.push({
          id: contId,
          dia: this.verifyDay(primeiroDia),
          diaNumerico: primeiroDia,
          data: this.moment(dataPrimeiroDia).format("DD/MM/YYYY"),
          folga: false,
        });

        dataPrimeiroDia = this.moment(dataPrimeiroDia)
          .add(1, "days")
          .format("YYYY-MM-DD");

        if (primeiroDia < 6) {
          primeiroDia++;
        } else {
          primeiroDia = 0;
        }

        contId++;
      }
    },
  },
  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
